// extracted by mini-css-extract-plugin
export default {"modal":"branchModal_modal__KgvrY","popup":"branchModal_popup__9c7LW"};